// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import { router } from './router'
import '../theme/index.css'
import ElementUI from 'element-ui'
import 'default-passive-events'
import 'babel-polyfill'
import GetUrl from './libs/utils/GetUrl';
import store from "./store";
import * as filters from "./libs/filters/filters.js"
import DialogDirectives from './libs/directives/DialogDirectives.js'
import TableDirective from './libs/directives/TableDirective.js'
import './assets/icon/iconfont.css'
import dayjs from 'dayjs'

Vue.config.productionTip = false;
Vue.use(ElementUI, { size: 'small' });
Vue.prototype.$GetUrl = GetUrl;
Vue.prototype.$dayjs = dayjs;

Object.keys(filters).forEach(key=>{ // 注册全局过滤器
  Vue.filter(key,filters[key])//插入过滤器名和对应方法
});

const directives = Object.assign({}, DialogDirectives, TableDirective)
Object.keys(directives).forEach(key=>{ // 注册全局自定义指令
  Vue.directive(key,directives[key])
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js